import {Component} from 'react';
import PropTypes from 'prop-types';

// http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
const numberWithCommas = value => {
    try {
        if (isNaN(parseFloat(value))) {
            // if this string value is going to result in NaN, just return empty string
            return '';
        }

        const parts = value.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        return parts.join('.');
    } catch(ex) {
        return '';
    }
};

class NumberInput extends Component {
    static defaultProps = {
        onChange: () => {}
    };

    static propTypes = {
        onChange: PropTypes.func,
        minValue: PropTypes.any,
        maxValue: PropTypes.any
    };

    constructor(props) {
        super(props);
        const {value = ''} = props;
        this.state = {value};
    }

    get value() {
        const {value} = this.state;
        return value;
    }

    getErrors(label = '') {
        const {value} = this.state;
        const {minValue: min, maxValue: max} = this.props;

        if (!value || !this.getRawValue(value)) {
            return [`${label} is empty`];
        }

        if (typeof min !== 'undefined') {
            const minValue = parseFloat(min);
            const currentValue = parseFloat(value);

            if (!isNaN(minValue) && !isNaN(currentValue) && minValue > value) {
                return [`Minimum value for ${label} is ${minValue}`];
            }
        }

        if (typeof max !== 'undefined') {
            const maxValue = parseFloat(max);
            const currentValue = parseFloat(value);

            if (!isNaN(maxValue) && !isNaN(currentValue) && maxValue < value) {
                return [`Maximum value for ${label} is ${maxValue}`];
            }
        }

        return [];
    }

    getRawValue(value) {
        return value.toString().match(/[\d+.]*/g).join('');
    }

    onChange(e) {
        const {value} = e.target;
        const {onChange} = this.props;
        onChange(this.getRawValue(value));
        this.setState({value});
    }

    prepForDisplay(value) {
        return numberWithCommas(value);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({value: nextProps.value});
    }

    render() {
        const {minValue, maxValue, ...input} = this.props;
        const {value} = this.state;
        return (
            <input
                type="tel"
                {...input}
                onChange={this.onChange.bind(this)}
                value={this.prepForDisplay(value)} />
        );
    }
}
class MoneyInput extends Component {
    render() {
        return (
            <div className="input-symbol-wrapper">
                <span className="input-symbol">$</span>
                <NumberInput {...this.props} />
            </div>
        );
    }
}

class PercentageInput extends Component {
    render() {
        return (
            <div className="input-symbol-wrapper">
                <span className="input-symbol">%</span>
                <NumberInput {...this.props} />
            </div>
        );
    }
}

export {
    NumberInput,
    MoneyInput,
    PercentageInput
};
